var swiper123 = new Swiper(".swapping-image-slider", {
      speed: 1500,
      effect: "fade",
        autoplay: {
            delay: 0, // 2.5 seconds between slides
            disableOnInteraction: false, // Keeps autoplay running after user interaction
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true, // Enable looping of slides
        pagination: {
            el: '.swiper-pagination',
            clickable: true, // Allow pagination navigation
        },
    });
swiper123.forEach(swiperMain => {

    swiperMain.autoplay.stop();
    
});

var swiperMainSliderElements = document.querySelectorAll('.swapping-image-slider');
swiperMainSliderElements.forEach((swiperMainSliderElement, index) => {
    swiperMainSliderElement.addEventListener('mouseleave', function() {
        swiper123[index].autoplay.stop();  // Stop autoplay when mouse enters
    });
    swiperMainSliderElement.addEventListener('mouseenter', function() {
        swiper123[index].autoplay.start();  // Stop autoplay when mouse enters
    });
});

 